import request from "@/utils/request";
const { scimSystem } = window.env;
const group = `${scimSystem}/api/v1/org/group`;
const organization = `${scimSystem}/api/v1/organization/page`;

const api = {
  page: params => request({
    url: `${group}/page`,
    method: "get",
    params
  }),
  group: data => request({
    url: `${group}`,
    method: "post",
    data
  }),
  groupId: (id, params) => request({
    url: `${group}/${id}`,
    method: "get",
    params
  }),
  all: params => request({
    url: `${organization}/all`,
    method: "get",
    params
  }),
  editOrg: data => request({
    url: `${group}`,
    method: "put",
    data
  })
};

export default api;
